<template>
  <div>
    <div class="row">
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label>25 - Código da tabela</label>
          <select
            v-model="procedimento.codigoTabela"
            data-test-id="select-procedimento-codigotabela"
            class="form-control input-sm"
            @change="alterouTabela"
          >
            <option disabled value="">Selecione</option>
            <option
              v-for="tabela in tabelas"
              :key="tabela._id"
              :value="tabela.nome"
              >{{ tabela.nome }}</option
            >
          </select>
        </div>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div
          :class="{
            'has-error':
              itemValidacao.codigo.$error || itemValidacao.nome.$error,
          }"
          class="form-group"
        >
          <label
            >26 - Código do procedimento / 27 - Descrição do procedimento
            <sup>(1)</sup></label
          >
          <BuscarSelecionar
            :classes-input="'form-control input-sm'"
            :lista="procedimentos"
            :selecionado="procedimentoSelecionado"
            :exibir-chave="false"
            :exibir="['codigoNome']"
            :minimo="1"
            @selecionar="selecionarProcedimento"
            @limpar="limparProcedimento"
            @recuperar="recuperarProcedimentos"
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div
          :class="{
            'has-error': itemValidacao.qtdSolicitada.$error,
          }"
          class="form-group"
        >
          <label>28 - Quantidade solicitada <sup>(1)</sup></label>
          <input
            v-model="procedimento.qtdSolicitada"
            v-mask="'999'"
            data-test-id="input-procedimento-qtdsolicitada"
            type="number"
            class="form-control input-sm"
            placeholder="Quantidade solicitada de um mesmo serviço/procedimento"
            @input="aoAtulizarQuantidadeSolicitada($event)"
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div
          :class="{
            'has-error': itemValidacao.qtdAutorizada.$error,
          }"
          class="form-group"
        >
          <label>29 - Quantidade autorizada <sup>(1)</sup></label>
          <input
            v-model="procedimento.qtdAutorizada"
            v-mask="'999'"
            data-test-id="input-procedimento-qtdautorizada"
            type="number"
            class="form-control input-sm"
            placeholder="Quantidade autorizada de um mesmo serviço/procedimento"
            @input="aoAtulizarQuantidadeAutorizada($event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import AwesomeMask from 'awesome-mask'

import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import ConvenioServico from '@/servicos/ConvenioServico'
import MensagemServico from '@/servicos/MensagemServico'

const convenioServico = new ConvenioServico()
const mensagemServico = new MensagemServico()

export default {
  name: 'ProcedimentoSolicitado',
  components: { BuscarSelecionar },
  directives: { mask: AwesomeMask },
  props: {
    procedimento: {
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
    index: {
      type: Number,
      required: true,
    },
    guia: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    visaoSimplificada: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      tabelas: [],
      procedimentos: [],
      procedimentoSelecionado: this.procedimento,
    }
  },
  computed: {
    itemValidacao() {
      return this.obterItemValidacao()
    },
  },
  watch: {
    procedimento() {
      this.processarProcedimento()
    },
    'guia.beneficiario.convenio'() {
      // this.limparProcedimento()
      this.tabelas =
        this.guia.beneficiario.convenio &&
        this.guia.beneficiario.convenio.tabelas.length
          ? this.guia.beneficiario.convenio.tabelas
          : []
      if (this.procedimento.codigoTabela) {
        const tabs = this.tabelas.find(
          (t) => t.nome === this.procedimento.codigoTabela
        )
        if (!tabs) {
          this.limparProcedimento()
        }
      }
    },
  },
  created() {
    if (
      this.guia.beneficiario.convenio &&
      this.guia.beneficiario.convenio.tabelas &&
      this.guia.beneficiario.convenio.tabelas.length
    ) {
      this.tabelas = this.guia.beneficiario.convenio.tabelas
    }
  },
  methods: {
    criarCampoCompativel(nome, erros = {}, touch = () => {}) {
      const errosCampo = Array.isArray(erros[nome]) ? erros[nome] : []
      return {
        $error: errosCampo.length > 0,
        $dirty:
          this.validations?.guia?.solicitacao?.procedimentos?.$dirty || false,
        required: !errosCampo.some((erro) => erro.$validator === 'required'),
        $touch: touch,
      }
    },
    obterItemValidacao() {
      const colecao = this.validations?.guia?.solicitacao?.procedimentos
      const each = colecao?.$each
      const noop = () => {
        if (colecao && typeof colecao.$touch === 'function') {
          colecao.$touch()
        }
      }

      if (Array.isArray(each)) {
        return each[this.index] || {}
      }

      const erros = each?.$response?.$errors?.[this.index] || {}
      return {
        codigo: this.criarCampoCompativel('codigo', erros, noop),
        nome: this.criarCampoCompativel('nome', erros, noop),
        qtdSolicitada: this.criarCampoCompativel('qtdSolicitada', erros, noop),
        qtdAutorizada: this.criarCampoCompativel('qtdAutorizada', erros, noop),
      }
    },
    tocarCampo(campo) {
      const item = this.itemValidacao
      const touch = item?.[campo]?.$touch
      if (typeof touch === 'function') {
        touch()
      } else {
        const colecao = this.validations?.guia?.solicitacao?.procedimentos
        if (colecao && typeof colecao.$touch === 'function') {
          colecao.$touch()
        }
      }
    },
    alterouTabela() {
      this.$emit('alterouTabela', { procedimento: this.procedimento })
    },
    processarProcedimento() {
      if (
        this.procedimento.codigo &&
        this.procedimento.nome &&
        this.guia.beneficiario.convenio._id
      ) {
        this.tabelas = this.guia.beneficiario.convenio.tabelas
        const tabela = this.tabelas.find(
          (t) => t.nome === this.procedimento.codigoTabela
        )
        convenioServico
          .recuperarProcedimentos({
            nome: this.procedimento.nome,
            skip: 0,
            limit: 1,
            orderBy: 'nome',
            codigo: this.procedimento.codigo,
            convenio: this.guia.beneficiario.convenio._id,
            idTabela: tabela._id,
          })
          .then((res) => {
            if (res.procedimentos.length) {
              this.procedimentos = []
              const procedimento = res.procedimentos[0].procedimentos
              procedimento.codigoNome = `${procedimento.codigo} - ${procedimento.nome}`
              this.selecionarProcedimento(procedimento)
            }
          })
      } else {
        this.limparProcedimento()
      }
    },
    aoAtulizarQuantidadeSolicitada(event) {
      this.tocarCampo('qtdSolicitada')
      this.procedimento.qtdAutorizada = event.target.value
      this.guia.procedimentosRealizados.procedimentos[this.index].qtdRealizada =
        event.target.value
    },
    aoAtulizarQuantidadeAutorizada(event) {
      this.tocarCampo('qtdAutorizada')
      this.guia.procedimentosRealizados.procedimentos[this.index].qtdRealizada =
        event.target.value
    },
    selecionarProcedimento(procedimento) {
      this.procedimentoSelecionado = procedimento
      this.$emit('selecionadoProcedimento', { procedimento, index: this.index })
    },
    limparProcedimento() {
      this.procedimentoSelecionado = {}
      this.$emit('limparProcedimento', { index: this.index })
    },
    recuperarProcedimentos(filtro) {
      if (this.guia.beneficiario.convenio) {
        const codigo = new RegExp('^[0-9]+$').test(filtro.palavra)
          ? filtro.palavra
          : ''
        const nome = new RegExp('^[a-z]+$', 'i').test(filtro.palavra)
          ? filtro.palavra
          : ''
        const tabela = this.tabelas.find(
          (t) => t.nome === this.procedimento.codigoTabela
        )
        const data = {
          nome: nome,
          skip: (filtro.pagina - 1) * filtro.limite,
          limit: filtro.limite,
          orderBy: filtro.chave,
          codigo: codigo,
          convenio: this.guia.beneficiario.convenio._id,
          idTabela: tabela._id,
        }
        convenioServico.recuperarProcedimentos(data).then((res) => {
          this.procedimentos = []
          res.procedimentos.forEach((procedimento) => {
            const p = procedimento.procedimentos
            p.codigoNome = `${p.codigo} - ${p.nome}`
            this.procedimentos.push(procedimento.procedimentos)
          })
        })
      } else {
        mensagemServico.alerta('Informe o plano do beneficiário.')
      }
    },
  },
}
</script>
